import { render } from "./IssueDetail.vue?vue&type=template&id=d1f29a8a&scoped=true"
import script from "./IssueDetail.vue?vue&type=script&lang=js"
export * from "./IssueDetail.vue?vue&type=script&lang=js"

import "./IssueDetail.vue?vue&type=style&index=0&id=d1f29a8a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1f29a8a"]])

export default __exports__